import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Modal, Switch, Popover, message, Popconfirm, Button, Icon, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExecuteMgrSider from '../ExecuteMgrSider';
import { CasCadeOption, SelectOption } from './TemplateModal';
import SortTemplate from '../../common/SortTemplate';
import AddTemplateField from './AddTemplateField';
import '../style/executeMgr.less';

class Template extends Component {
    state = {
        checked: false,
        loading: false,
        pageLoading: false,
        data: [],
        dataList: [],
    }

    componentDidMount() {
        this.queryIsEnable(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params != this.props.params) {
            this.queryIsEnable(nextProps);
        }
    }

    queryIsEnable = (props) => {
        const { params = {} } = props;
        const { followBoardId } = params;
        if (!followBoardId) {
            return;
        }
        const options = {
            method: 'post',
            url: API_URL.executeMgr.isEnabledFollowBoard,
            data: {
                followBoardId: followBoardId,
            },
            dataType: 'json',
            doneResult: (res) => {
                if (!res.error) {
                    const { params } = this.props;
                    const { patientTypeName, noPatientTypeName, patientTypeId, noPatientTypeId } = params;
                    const type = patientTypeName ? 'patient' : 'noPatient';
                    const typeName = patientTypeName || noPatientTypeName;
                    const followBoardTypeId = patientTypeId || noPatientTypeId;

                    this.setState({
                        type,
                        typeName,
                        checked: res.isEnabled,
                        followBoardTypeId,
                    }, () => {
                        this.loadData();
                    });
                }
            },
        }
        $.sendRequest(options);
    }

    loadData = (isPageLoading) => {
        const { followBoardTypeId } = this.state;
        !isPageLoading && this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.executeMgr.queryInvestigationFollowDetail,
            data: {
                followBoardTypeId,
            },
            dataType: 'json',
            doneResult: (res) => {
                !isPageLoading && this.setState({ loading: false });
                this.setState({
                    data: res.data,
                    deep: res.depth,
                });
            },
        }
        $.sendRequest(options);
    }

    handleSwitchChange = (checked) => {
        const { params } = this.props;
        const { followBoardId, followBoardName } = params;
        let title, content, url;
        if (checked) {
            title = <strong>{`是否关闭模板"${followBoardName}"?`}</strong>;
            content = '关闭后，其他用户在项目执行中无法查看该模板内容';
            url = API_URL.executeMgr.unEnabledFollowBoard;
        } else {
            title = <strong>{`是否启用模板"${followBoardName}"?`}</strong>;
            content = '启用后，其他用户将在项目执行中录入、查看该模板内容';
            url = API_URL.executeMgr.enabledFollowBoard;
        }
        Modal.confirm({
            title,
            content,
            onOk: () => {
                this.setState({ pageLoading: true });
                const options = {
                    method: 'post',
                    url,
                    data: {
                        followBoardId,
                    },
                    dataType: 'json',
                    doneResult: (res) => {
                        if (!res.error) {
                            message.success(res.success);
                            this.setState({
                                checked: !checked,
                                pageLoading: false,
                            }, () => {
                                this.loadData(true);
                            });
                        }
                    },
                    errorResult: () => {
                        this.setState({ pageLoading: false });
                    }
                }
                $.sendRequest(options);
            }
        });
    }

    delete = (followBoardDetailId, rowCol) => {
        const { data } = this.state;

        const followBoardDetails = {};
        let len = rowCol.length - 1, newData = [...data];
        for (let i = 0; i < len; i++) {
            const key = rowCol[i] - 1;
            followBoardDetails[`followBoardDetails[${i}].rowSpan`] = newData[key].rowSpan;
            followBoardDetails[`followBoardDetails[${i}].colSpan`] = newData[key].colSpan - 1;
            followBoardDetails[`followBoardDetails[${i}].followBoardDetailId`] = newData[key].followBoardDetailId;
            newData = [...newData[key].children];
        }
        const options = {
            method: 'post',
            url: API_URL.executeMgr.deleteInvestigationFollowDetail,
            data: {
                followBoardDetailId,
                ...followBoardDetails,
            },
            dataType: 'json',
            doneResult: (res) => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                }
            },
        }
        $.sendRequest(options);
    }

    handleBtnClick = (type) => {
        const  { params } = this.props;
        const { patientTypeId, noPatientTypeId, patientTypeName, noPatientTypeName } = params;

        let typeName, followBoardTypeId;
        if (type == 'patient') {
            typeName = patientTypeName;
            followBoardTypeId = patientTypeId;
        } else {
            typeName = noPatientTypeName;
            followBoardTypeId = noPatientTypeId;
        }
        this.setState({
            type,
            typeName,
            followBoardTypeId,
        }, () => {
            this.loadData();
        });
    }


    getColumns = () => {
        const { deep = 1, checked } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
        }];
        if (deep == 1) {
            columns.push({
                title: '字段名称',
                dataIndex: 'col1',
                key: 'col1',
            });  
        } else if (deep > 1) {
            for (let i = 1; i <= deep; i++) {
                columns.push({
                    title: `字段名称(${i})`,
                    dataIndex: `col${i}`,
                    key: `col${i}`,
                    render: (value, record, index) => {
                        const obj = {
                            children: value,
                            props: {},
                        };
                        if (!record[`colSpan${i}`]) {
                            obj.props.colSpan = 0;
                        } else {
                            obj.props.colSpan = record[`colSpan${i}`];
                        }
                        if (!record[`rowSpan${i}`]) {
                            obj.props.rowSpan = 0;
                        } else {
                            obj.props.rowSpan = record[`rowSpan${i}`];
                        }
                        return obj;
                    }
                }); 
            }
        }
        columns.push({
            title: '字段类型',
            dataIndex: 'fieldTypeStr',
            key: 'fieldTypeStr',
        }, {
            title: '填写方式',
            dataIndex: 'fieldWebTypeStr',
            key: 'fieldWebTypeStr',
        }, {
            title: '是否必填',
            dataIndex: 'fieldIsRequireStr',
            key: 'fieldIsRequireStr',
        }, {
            title: '可选项',
            dataIndex: 'optionStrShow',
            key: 'optionStrShow',
        });

        columns.push({
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 120,
            render: (text, record) => {
                const hasValue = !!record.optionStrShow;
                const showCascade = record.fieldWebTypeStr == '级联下拉框';
                const showSelect = record.fieldWebTypeStr == '单选' || record.fieldWebTypeStr == '多选' || record.fieldWebTypeStr == '下拉框';
                return (
                    <span>
                        {
                            !checked
                            ?
                                <span>
                                    <a disabled>修改</a>
                                    <span className="ant-divider"/>
                                    <a disabled>删除</a>
                                    <span className="ant-divider"/>
                                    <a disabled>{!showCascade ? '设置可选项' : '设置级联可选项'}</a>
                                </span>
                            :
                                <span>
                                    <a disabled={!record.investigationId} onClick={() => this.showAddTemplateField(record)}>修改</a>
                                    <span className="ant-divider"/>
                                    <Popconfirm title={'确定要删除吗?'} onConfirm={() => this.delete(record.followBoardDetailId, record.rowCol)} okText="确定" cancelText="取消">
                                        <a disabled={!record.investigationId}>删除</a>
                                    </Popconfirm>
                                    <span className="ant-divider"/>
                                    {
                                        showCascade
                                        ?   
                                            <a disabled={!hasValue} onClick={() => this.showSelectModal('cascade', record.followBoardDetailId)}>设置级联可选项</a>
                                        :  
                                            <a disabled={!showSelect} onClick={() => this.showSelectModal('select', record.followBoardDetailId)}>设置可选项</a>
                                    }
                                </span>
                        }
                    </span>
                );
            },
        });
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = [];
        this.loopData(dataSource, data, {}, 1, 1);
        dataSource.forEach((item, index) => {
            item.index = index + 1;
            delete item.colSpan;
            delete item.rowSpan;
        });
        return dataSource;
    }

    loopData = (list, data = [], params, key) => {
        data.forEach((item, index) => {
            if (item.children && item.children.length > 0) {
                if (index) {
                    params = {};
                }
                params[`col${key}`] = item.fieldName;
                params[`colSpan${key}`] = item.rowSpan;
                params[`rowSpan${key}`] = item.colSpan;
                this.loopData(list, item.children, params, key + 1);
            } else {
                if (index === 0) {
                    list.push({
                        ...item,
                        ...params,
                        [`col${key}`]: item.fieldName,
                        [`colSpan${key}`]: item.rowSpan,
                        [`rowSpan${key}`]: item.colSpan,
                        fieldTypeStr: this.getType(item.fieldType),
                        fieldWebTypeStr: this.getWebType(item.fieldType, item.fieldWebType),
                        fieldIsRequireStr: item.fieldIsRequire === '0' ? '否' : '是',
                    });
                    params = {};
                } else {
                    list.push({
                        ...item,
                        [`col${key}`]: item.fieldName,
                        [`colSpan${key}`]: item.rowSpan,
                        [`rowSpan${key}`]: item.colSpan,
                        fieldTypeStr: this.getType(item.fieldType),
                        fieldWebTypeStr: this.getWebType(item.fieldType, item.fieldWebType),
                        fieldIsRequireStr: item.fieldIsRequire === '0' ? '否' : '是',
                    });
                }
            }
        })
    }

    showSelectModal = (type, id) => {
        if (type == 'select') {
            this.SelectOptionRef.show(id);
        } else if (type == 'cascade') {
            this.CasCadeOptionRef.show(id);
        }
    }

    showAddTemplateField = (record) => {
        const { followBoardTypeId } = this.state;
        let type;
        const params = {
            parentId: '',
            followBoardTypeId,
        };
        if (!record) {
            type = 'add';
            params.parentId = '';
            params.fieldType = 'TEXT';
            params.fieldWebType = 'INPUT';
            params.fieldIsRequire = '1';
        } else {
            type = 'edit';
            params.parentId = record.parentId;
            params.fieldName = record.fieldName;
            params.fieldType = record.fieldType;
            params.fieldWebType = record.fieldWebType;
            params.fieldIsRequire = record.fieldIsRequire;
            params.followBoardDetailId = record.followBoardDetailId;
        }
        this.AddTemplateFieldRef.show(type, params);
    }

    getType = (type) => {
        if (type == 'DATE') {
            return '时间型'
        } else if (type == 'NUMBER') {
            return '数值型';
        }
        return '文本型';
    }

    getWebType = (type, webType) => {
        if (type == 'NUMBER') {
            return '数值文本框';
        } else if (type == 'TEXT') {
            if (webType == 'INPUT') {
                return '文本框';
            } else if (webType == 'TEXTAREA') {
                return '文本域';
            } else if (webType == 'RADIO') {
                return '单选';
            } else if (webType == 'CHECKBOX') {
                return '多选';
            } else if (webType == 'SELECT') {
                return '下拉框';
            } else if (webType == 'CASCADE_SELECT') {
                return '级联下拉框';
            }
        } else if (type == 'DATE') {
            if (webType == 'DATE_YEAR_MONTH_DAY') {
                return '时间控件(年月日)';
            } else if (webType == 'DATE_YEAR_MONTH') {
                return '时间控件(年月)';
            } else if (webType == 'DATE_YEAR_MONTH_DAY_HOUR_MINUTE') {
                return '时间控件(年月日时分)';
            }
        }
        return '未知格式';
    }

    sort = () => {
        const { data = [] } = this.state;
        this.SortTemplateRef.show(data);
    }

    render() {
        const{ params = {} } = this.props;
        const { curRole, investigationSiteName } = sessionStorage;
        const { deep = 1, type = 'patient', data, checked, loading, pageLoading, followBoardTypeId } = this.state;
        const { comments = '', followBoardName, isRelatedPatient, patientTypeName, noPatientTypeName } = params;
        const isShow= !investigationSiteName && (curRole == 'PA' || curRole == 'PM' || curRole == 'CTA');
        return (
            <div className="content">
                    <ExecuteMgrSider selectKey={patientTypeName || noPatientTypeName} />
                    <div className="main">
                    <Spin spinning={pageLoading}>
                        <div className="breadcrumb-bar tac">
                            {
                                isShow &&
                                <Popover
                                    placement="right"
                                    overlayClassName="propercent-pop"
                                    content={<pre style={{ width: 240, whiteSpace: 'pre-line' }}>{comments}</pre>}
                                >
                                    <div style={{float: 'left'}}>
                                        <Icon type="info-circle" style={{color: '#5750c9', marginRight: 4}} />
                                        <a>配置说明</a>
                                    </div>
                                </Popover>
                            }
                            <h2 className="title">
                                {followBoardName}
                                <Switch size="small" style={{ marginLeft: 10 }} checked={checked} onChange={() => this.handleSwitchChange(checked)} />
                            </h2>
                        </div>
                        {
                            isRelatedPatient == "BOTH" &&
                            <div className="tab_flex" style={{margin: '20px 0'}}>
                                <a className={type == "patient" ? "curr" : ""} onClick={() => this.handleBtnClick('patient')} >{`与患者有关的${followBoardName}`}</a>
                                <a className={type == "noPatient" ? "curr" : ""} onClick={() => this.handleBtnClick('noPatient')} >{`与患者无关的${followBoardName}`}</a>
                            </div>
                        }
                        <div className="filter-bar tar">
                            <Button type="primary" onClick={this.sort} disabled={!checked}>排序调整</Button>
                            <Button type="primary" onClick={() => this.showAddTemplateField()} disabled={!checked}>添加</Button>
                        </div>
                        <div className="main-content">
                            <Table
                                columns={this.getColumns()}
                                dataSource={this.getDataSource()}
                                rowKey={record => record.index}
                                loading={loading}
                                pagination={false}
                            />
                        </div>
                        </Spin>
                    </div>
                    <CasCadeOption ref={el => this.CasCadeOptionRef = el }/>
                    <AddTemplateField ref={el => this.AddTemplateFieldRef = el} data={data} deep={deep} loadData={this.loadData} />
                    <SortTemplate
                        ref={el => this.SortTemplateRef = el}
                        followBoardTypeId={followBoardTypeId}
                        loadData={this.loadData}
                        title={followBoardName}
                    />
                    <SelectOption
                        ref={el => {this.SelectOptionRef = el;}}
                        loadData={this.loadData}
                    />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        params: state.templateState.selectItem || {},
    }
}

export default connect(mapStateToProps, null)(Template);


// WEBPACK FOOTER //
// ./src/components/executeMgr/template/index.js